import React from 'react';
import ProgressiveImage from 'react-progressive-image';

const ProgressiveImg = (props) => {

  const {
    delay,
    src,
    alt,
    title,
    classe,
    placeholder,

  } = props ;

  return (
    <ProgressiveImage
      delay={delay}
      src={src}
      placeholder={placeholder}
    >
      {(src, loading) => (
        <img 
          src={src} 
          className={classe}
          title={title}
          alt={alt}
          style={{ opacity: loading ? 0.5 : 1 }}
        />
      )}
    </ProgressiveImage>
  );
}

export default ProgressiveImg;
